export default "__VITE_ASSET__CnuylWxL__"